module.exports = __webpack_public_path__ + "static/media/hands.4ee7d258.svg";